// core
import { Injectable } from '@angular/core';

// services
import { ApiService } from '../services/api.service';

@Injectable({
  providedIn: 'root'
})
export class IntercomApiService extends ApiService {

  getHash(): Promise<any>  {
    return this.get('/service/intercom/hmac').toPromise();
  }
}
